import React, { useState, useEffect } from 'react';
import { saveVote, getVoteHistory } from '../services/voteService';
import BiasIndicator from './BiasIndicator'; 

const DebateCard = ({ debateData, biasData }) => {
    const [voteStats, setVoteStats] = useState(null);
    const [shareUrl, setShareUrl] = useState('');
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (debateData?.topic) {
            
            loadVoteHistory(debateData.topic);
            
            
            const baseUrl = window.location.origin;
            const repoPath = '/debate-bot'; 
            const shareableUrl = `${baseUrl}${repoPath}?topic=${encodeURIComponent(debateData.topic)}`;
            setShareUrl(shareableUrl);
        }
    }, [debateData?.topic]);

    const loadVoteHistory = async (topic) => {
        try {
            const response = await getVoteHistory(topic);
            setVoteStats(response.analytics[topic]);
        } catch (error) {
            console.error('Error loading vote history:', error);
        }
    };

    const handleCopyLink = () => {
        navigator.clipboard.writeText(shareUrl)
            .then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            })
            .catch(err => console.error('Failed to copy: ', err));
    };

    if (!debateData) return null;

    return (
        <div className="debate-card">
            <div className="debate-card-header">
                <h3>{debateData.topic}</h3>
                <div className="share-container">
                    <button className="share-button" onClick={handleCopyLink}>
                        {copied ? 'Copied!' : 'Copy Share Link'}
                    </button>
                </div>
            </div>
            
            <div className="debate-summary">
                <div className="debate-side for-side">
                    <h4>Key Arguments For</h4>
                    <ul>
                        {debateData.argumentsFor.map((arg, index) => (
                            <li key={index}>{arg.title}</li>
                        ))}
                    </ul>
                </div>
                <div className="debate-divider" />
                <div className="debate-side against-side">
                    <h4>Key Arguments Against</h4>
                    <ul>
                        {debateData.argumentsAgainst.map((arg, index) => (
                            <li key={index}>{arg.title}</li>
                        ))}
                    </ul>
                </div>
            </div>
            
            {biasData && <BiasIndicator biasData={biasData} />}
            
            {voteStats && (
                <div className="debate-card-votes">
                    <h5>How People Voted</h5>
                    <div className="vote-chart mini">
                        {voteStats.for > 0 || voteStats.against > 0 ? (
                            <>
                                <div 
                                    className="vote-bar vote-for"
                                    style={{ 
                                        width: `${voteStats.for > 0 ? 
                                            (voteStats.for / (voteStats.for + voteStats.against)) * 100 : 0}%` 
                                    }}
                                >
                                    {Math.round((voteStats.for / (voteStats.for + voteStats.against)) * 100)}%
                                </div>
                                <div 
                                    className="vote-bar vote-against"
                                    style={{ 
                                        width: `${voteStats.against > 0 ? 
                                            (voteStats.against / (voteStats.for + voteStats.against)) * 100 : 0}%` 
                                    }}
                                >
                                    {Math.round((voteStats.against / (voteStats.for + voteStats.against)) * 100)}%
                                </div>
                            </>
                        ) : (
                            <div className="no-votes">No votes yet</div>
                        )}
                    </div>
                    <div className="vote-count">
                        <span>{voteStats.for} For</span>
                        <span>{voteStats.against} Against</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DebateCard;